var map = {
	"./captures/1.jpg": 190,
	"./themes/environment/frida.jpg": 191,
	"./themes/environment/pingo.jpg": 192,
	"./themes/environment/romeo.jpg": 193,
	"./themes/environment/triton.jpg": 194,
	"./themes/message/best.jpg": 195,
	"./themes/message/greetings.jpg": 196,
	"./themes/message/miami.jpg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;